import styles from "./zoom-level-toggle.module.css";

import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import ToggleButtonsComponent from "../../../../../components/toggle-button/ToggleButtonGroup";
import { ClientDashboardStore } from "../../../store/store";
import UserSettingsStore, {
    UserSettings,
} from "../../../../../store/user-settings";

export interface ZoomLevelToggleProps {
    clientDashboardStore?: ClientDashboardStore;
    userSettingsStore?: UserSettingsStore;
}

function ZoomLevelToggle(props: ZoomLevelToggleProps) {
    const clientDashboardStore = props.clientDashboardStore!;
    const userSettingsStore = props.userSettingsStore!;

    const zoomLevel = userSettingsStore.getUserSetting(UserSettings.ZOOM_LEVEL);
    const { t } = useTranslation("client-grid");

    const buttons = [
        {
            id: "1",
            text: t("100%"),
        },
        { id: "2", text: t("200%") },
        { id: "3", text: t("300%") },
        { id: "4", text: t("400%") },
        { id: "5", text: t("500%") },
    ];

    const render = () => {
        return (
            <div className={styles["container"]}>
                <ToggleButtonsComponent
                    buttons={buttons}
                    selectedID={zoomLevel + ""}
                    onChange={(ID: string) => {
                        if (ID !== null) {
                            userSettingsStore.setUserSetting(
                                UserSettings.ZOOM_LEVEL,
                                Number(ID)
                            );
                        }
                    }}
                />
            </div>
        );
    };

    return render();
}

export default inject(
    "clientDashboardStore",
    "userSettingsStore"
)(observer(ZoomLevelToggle));
